import { render, staticRenderFns } from "./MatrixSelectChoice.vue?vue&type=template&id=15e73974&scoped=true"
import script from "./MatrixSelectChoice.vue?vue&type=script&lang=js"
export * from "./MatrixSelectChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e73974",
  null
  
)

export default component.exports